import { CustomerMergeClient } from "../../../../../../Wrap/Api/Customer/CustomerMerge";

export class CustomerMergeAction {
    public static getCustomerMerge(customerId1: string, customerId2: string, callback) {
        const client = new CustomerMergeClient();
        const promise = client.get(Number(customerId1), Number(customerId2));
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static mergeCustomer(fromCustomerId: string, toCustomerId: string, callback) {
        const client = new CustomerMergeClient();
        const promise = client.post(Number(fromCustomerId), Number(toCustomerId));
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }
}
